import React from "react";
import euComplianceMark from "../../assets/eu-compliance-mark.png";

export function LandingPlatformStackAsset({ className = "landing-hero__platform-stack" }) {
  return (
    <div className={`${className} landing-hero__platform-stack--mark`} aria-hidden="true">
      <img
        src={euComplianceMark}
        alt=""
        className="landing-hero__float-logo"
        draggable={false}
      />
    </div>
  );
}
